import { render, staticRenderFns } from "./ConfirmationResult.vue?vue&type=template&id=276af054&scoped=true"
import script from "./ConfirmationResult.vue?vue&type=script&lang=js"
export * from "./ConfirmationResult.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationResult.vue?vue&type=style&index=0&id=276af054&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276af054",
  null
  
)

export default component.exports